export default (axios) => ({
    getRedirect: (slug) => axios.get(`/b/CustomRedirect/${slug}`).then((_) => _.data),
});
